import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/vendors/extra-reducers';
import reducers from 'src/redux/vendors/reducers';
import { vendorInitialState } from './types';

const vendorSlice = createSlice({
  name: 'vendors',
  initialState: vendorInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { clearVendorListData, updateVendorDetails, updateVendorOnboardStatus } =
  vendorSlice.actions;

export default vendorSlice.reducer;
